﻿export class ComplaintAnswer {
    id: number;
    comment: string;
    dateCreated: Date;
    userName: string;
    complaintId: number;
    userId: number;
    languageId: number;
   

    
}